import React, { useState } from 'react';
import { Dialog, Grid, useMediaQuery, useTheme } from '@material-ui/core';
import * as assets from '@assets';
import { useErrorDialogStyles } from './styles';
import { CustomizedButton, CustomizedTypography } from '@components/Customized';
import useServiceCheck from '@hooks/useServiceCheck';

const ErrorNoticePresenter = () => {
  const matches = useMediaQuery(useTheme().breakpoints.down('xs'));
  const classes = useErrorDialogStyles();

  const {
    serviceStatus,
    noticeOpen,
    date,
    startedTime,
    expiredTime
  } = useServiceCheck();

  const [open, setOpen] = useState(noticeOpen);

  const handleClose = () => {
    if (serviceStatus === 'ServiceCheck') {
      return;
    }
    setOpen(false);
  };

  if (!open || serviceStatus === 'Test') return null;

  return (
    <Dialog
      open={open}
      classes={{ paper: classes.paper }}
      onClose={handleClose}
    >
      <img src={assets.SadMans3} alt="타이틀" />

      <Grid container className={classes.titleRoot}>
        <CustomizedTypography
          variant={matches ? 'h3' : 'h2'}
          fontWeight="700"
          color="textPrimary"
        >
          {serviceStatus === 'ServiceCheck' && '서비스 점검 안내'}
          {serviceStatus === 'Unstable' && '서비스 긴급 점검 안내'}
          {serviceStatus === 'Pre' && '서비스 점검 사전 안내'}
        </CustomizedTypography>
      </Grid>

      {(serviceStatus === 'ServiceCheck' || serviceStatus === 'Pre') && (
        <Grid container className={classes.contentRoot}>
          <CustomizedTypography
            className={classes.description}
            color="textSecondary"
            variant={matches ? 'body2' : 'body1'}
            gutterBottoms={matches ? 40 : 48}
          >
            {matches ? (
              <React.Fragment>
                서비스를 이용해 주시는 고객님께 감사드립니다. 서비스 점검 시간
                동안 사용이 일시 중단될 예정이오니 이용에 참고 부탁드립니다. 더
                나은 서비스를 제공하기 위한 과정임을 너그럽게 양해 부탁드립니다.
              </React.Fragment>
            ) : (
              <React.Fragment>
                서비스를 이용해 주시는 고객님께 감사드립니다.
                <br />
                서비스 점검 시간 동안 사용이 일시 중단될 예정이오니 이용에 참고
                부탁드립니다.
                <br />더 나은 서비스를 제공하기 위한 과정임을 너그럽게 양해
                부탁드립니다.
              </React.Fragment>
            )}
          </CustomizedTypography>

          <CustomizedTypography
            color="textPrimary"
            fontWeight="700"
            variant="body1"
            gutterBottoms={16}
          >
            서비스 점검 일시
          </CustomizedTypography>

          <Grid container className={classes.timeZoneRoot}>
            <CustomizedTypography
              color="textPrimary"
              variant={matches ? 'body1' : 'h4'}
              fontWeight="500"
            >
              {date}&nbsp;
            </CustomizedTypography>
            <span className="time">
              {startedTime} ~ {expiredTime}
            </span>
          </Grid>
          {serviceStatus === 'Pre' && (
            <Grid container style={{ marginTop: 32 }}>
              <CustomizedButton
                variant="contained"
                color="primary"
                size="large"
                fullWidth
                onClick={handleClose}
              >
                닫기
              </CustomizedButton>
            </Grid>
          )}
        </Grid>
      )}

      {serviceStatus === 'Unstable' && (
        <Grid container className={classes.contentRoot}>
          <CustomizedTypography
            className={classes.description}
            color="textSecondary"
            variant={matches ? 'body2' : 'body1'}
            gutterBottoms={matches ? 40 : 48}
          >
            {matches ? (
              <React.Fragment>
                서비스 접속지연 및 장애 현상이 발견되어 긴급 서버 대응 중이나
                &nbsp;
                <span
                  className={`bold ${classes.span} ${
                    matches ? 'body2' : 'body1'
                  } textPrimary`}
                >
                  서비스 이용이 불안정할 수 있습니다.&nbsp;
                </span>
                <CustomizedTypography
                  style={{
                    display: 'block',
                    marginTop: 20,
                    wordBreak: 'break-all'
                  }}
                  color="textSecondary"
                  variant={matches ? 'body2' : 'body1'}
                  align="left"
                >
                  이용에 불편을 드려 죄송하며, 신속하게 정상 서비스가 제공될 수
                  있도록 최선을 다해 노력하겠습니다. 서비스 이용 중 불편하신 점
                  및 장애 사항은&nbsp;
                  <span
                    className={`${classes.span} ${
                      matches ? 'body2' : 'body1'
                    } primary bold`}
                  >
                    우측하단 채널톡으로 문의
                  </span>
                  주시면 빠른 조치토록 하겠습니다.
                </CustomizedTypography>
              </React.Fragment>
            ) : (
              <React.Fragment>
                서비스 접속지연 및 장애 현상이 발견되어 긴급 서버 대응 중이나
                <br />
                <span
                  className={`${classes.span} ${
                    matches ? 'body2' : 'body1'
                  } textPrimary bold m-32`}
                >
                  서비스 이용이 불안정할 수 있습니다.
                  <br />
                </span>
                이용에 불편을 드려 죄송하며, 신속하게 정상 서비스가 제공될 수
                있도록 최선을 다해 노력하겠습니다. 서비스 이용 중 불편하신 점 및
                장애 사항은&nbsp;
                <span
                  className={`${classes.span} ${
                    matches ? 'body2' : 'body1'
                  } primary bold`}
                >
                  우측하단 채널톡으로 문의
                </span>
                주시면 빠른 조치토록 하겠습니다.
              </React.Fragment>
            )}
          </CustomizedTypography>

          <Grid container>
            <CustomizedButton
              onClick={handleClose}
              fullWidth
              size="large"
              variant="contained"
              color="primary"
            >
              확인
            </CustomizedButton>
          </Grid>
        </Grid>
      )}
    </Dialog>
  );
};

export default ErrorNoticePresenter;
